import React from 'react';
import { useTranslation } from 'react-i18next';
import EAChip from '../../../shared/Chip/EAChip';
import EATooltip from '../../../shared/EATooltip/EATooltip';

interface IProps {
  availableSpots: number;
  capacity: number;
  hasNoSpaces: boolean;
  hasLastSpaces: boolean;
  hasWaitlistAvailable: boolean;
  assignedStatus: boolean;
  waitList: boolean;
  waitListPosition: number;
  className?: string;
}

const ExerciseStatusChips: React.FC<IProps> = ({
  hasNoSpaces,
  hasLastSpaces,
  hasWaitlistAvailable,
  assignedStatus,
  waitList,
  waitListPosition,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`exercise-status-chips ${className}`}>
      {hasNoSpaces && <EAChip label={t("brak_miejsc")} variant="error" />}
      {hasLastSpaces && <EAChip label={t("ostatnie_miejsca")} variant="warning" />}
      {hasWaitlistAvailable && (
          <EAChip label={t("dostepna_lista_rezerwowa")} variant="success" />
      )}
      {assignedStatus && waitList === false && <EAChip label={t("jestes_zapisany")} variant="success" />}
      {waitList === true && (
        <EATooltip content={`Lista rezerwowa, jesteś ${waitListPosition} w kolejce.`} position="right">
          <EAChip label={t("lista_rezerwowa")} variant="warning" badge={waitListPosition} />
        </EATooltip>
      )}
    </div>
  );
};

export default ExerciseStatusChips;
